import header from '../views/common/header';
import gnb from '../views/common/gnb';

export default [
  {
    path: '/views/examples/tree',
    meta: { hiddenGroupSelector: true },
    components: {
      default: () => import('../views/examples/Tree.vue'),
      header,
      gnb,
    },
  },
];
